import axios from 'axios';
import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { HOME_DELIVERY } from '../../constants/paths/api';
// import { IHomeDeliveryResponse } from '../../interfaces/forms/homeDeliveryForm';
import { getHomeDeliveryDataModel } from '../../helpers/apiHelpers/homeDeliveryHelpers';
import { RootState } from '../../store';
import { H2 } from '../base/typography';
import SuccessOrFailure from '../successOrFailure';
import { homeDeliveryInitialValues, homeDeliverySchema } from './homeDelivery.schema';
import * as StyledHomeDelivery from './homeDelivery.styles';
import HomeDeliveryFormFields from './homeDeliveryFormFields';

interface Props {
	noScroll?: boolean;
}

const HomeDelivery: FC<Props> = ({ noScroll }) => {
	const { t } = useTranslation('generalForm');
	const pageReducer = useSelector((store: RootState) => store.pageReducer);
	const { page } = pageReducer;
	const [hasSubmitted, setHasSubmitted] = useState(false);
	const [error, setError] = useState(false);

	const onSubmit = values => {
		const { SendEmailTo } = page.Values;

		const model = getHomeDeliveryDataModel(values, SendEmailTo);

		axios
			.post(HOME_DELIVERY, model)
			.then(response => {
				setHasSubmitted(true);
				setError(response.data.error);
				if (!noScroll) window.scrollTo(0, 0);
			})
			.catch(() => {
				setHasSubmitted(true);
				setError(true);
				if (!noScroll) window.scrollTo(0, 0);
			});
	};

	return (
		<StyledHomeDelivery.Wrapper>
			{!hasSubmitted && (
				<>
					<H2>{t('homeDelivery')}</H2>
					<StyledHomeDelivery.Info>{t('homeDeliveryInfo')}</StyledHomeDelivery.Info>
					<Formik
						initialValues={homeDeliveryInitialValues}
						enableReinitialize
						validationSchema={homeDeliverySchema}
						onSubmit={onSubmit}>
						{({
							values,
							handleSubmit,
							setFieldTouched,
							setFieldValue,
							isSubmitting,
							status,
							touched,
							errors,
						}) => (
							<form onSubmit={handleSubmit}>
								{!status && (
									<HomeDeliveryFormFields
										values={values}
										setFieldTouched={setFieldTouched}
										setFieldValue={setFieldValue}
										isSubmitting={isSubmitting}
										touched={touched}
										errors={errors}
									/>
								)}
							</form>
						)}
					</Formik>
				</>
			)}
			<SuccessOrFailure hasSubmitted={hasSubmitted} success={!error} messageArray={[t('successMessage')]} />
		</StyledHomeDelivery.Wrapper>
	);
};

export default HomeDelivery;
